import { Link, useLocation, Outlet } from 'react-router-dom';
import { logout } from '../../utils/auth';

const ZPanelLayout = () => {
    const location = useLocation();

    const handleLogout = () => {
        logout('/zpanel/login');
    };

    const navItems = [
        { path: '/zpanel', label: 'Organizasyonlar' },
        { path: '/zpanel/subscription-plans', label: 'Abonelik Planları' },
    ];

    return (
        <div className="min-h-screen bg-slate-900 flex">
            <aside className="w-64 bg-slate-800 border-r border-slate-700 flex flex-col">
                <div className="p-4 border-b border-slate-700">
                    <h1 className="text-xl font-bold text-amber-500">ZPanel</h1>
                    <p className="text-xs text-slate-400 mt-0.5">Müşteri Yönetimi</p>
                </div>
                <nav className="flex-1 p-2">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`block px-3 py-2 rounded-lg text-sm font-medium transition ${
                                location.pathname === item.path || (item.path !== '/zpanel' && location.pathname.startsWith(item.path))
                                    ? 'bg-amber-600/20 text-amber-400'
                                    : 'text-slate-400 hover:bg-slate-700 hover:text-white'
                            }`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>
                <div className="p-2 border-t border-slate-700">
                    <a href="/" className="block px-3 py-2 text-sm text-slate-400 hover:text-white">Menü Sitesi</a>
                    <button onClick={handleLogout} className="w-full text-left px-3 py-2 text-sm text-slate-400 hover:text-red-400">
                        Çıkış
                    </button>
                </div>
            </aside>
            <main className="flex-1 overflow-auto">
                <Outlet />
            </main>
        </div>
    );
};

export default ZPanelLayout;
